import { SearchField } from '@main/complykit/components/search-field';
import { Column, Table } from '@tanstack/react-table';
import useDebounceFn from 'ahooks/es/useDebounceFn';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function GlobalFilter<TData>({ table }: { table: Table<TData> }) {
  const { t } = useTranslation('ui');
  const [inputValue, setInputValue] = useState(
    () => (table.getState().globalFilter as string | undefined) ?? '',
  );

  const { run: debouncedSetFilter } = useDebounceFn(
    (value: string) => table.setGlobalFilter(value),
    { wait: 200 },
  );

  const handleChange = (value: string) => {
    setInputValue(value);
    debouncedSetFilter(value);
  };

  return (
    <SearchField
      aria-label={t('table.search.label')}
      placeholder={t('table.search.placeholder')}
      clearLabel={t('table.search.clear')}
      value={inputValue}
      onChange={handleChange}
    />
  );
}

export function getColumnCanGlobalFilter<TData>(column: Column<TData, unknown>): boolean {
  return !!column.columnDef.meta?.globalFilterFn;
}
